// extracted by css-extract-rspack-plugin
module.exports =  {"otherBtmInfoText":"UhrCS","budgetHistoryWrapper":"p33Pk","cardWrap":"ZR70L","timeLineWrap":"ULtlC","timeLine":"GuI8Y","yearTextWrap":"APS5l","blueLine":"Gtr3r","active":"Z6ZsS"};